import React from 'react';

import { BaseButton } from '@components/primitives';

import type { CancelButtonProperties } from './CancelButton.types';

export const CancelButton: React.FC<CancelButtonProperties> = ({
  onClick,
  isSubmitting,
  disabled,
  color = 'error',
  label,
  dataTest = 'cancel_button',
  sx,
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <BaseButton
      dataTest={dataTest}
      id={dataTest}
      onClick={handleClick}
      color={color}
      disabled={isSubmitting || disabled}
      size='large'
      sx={{ width: '100%', ...sx }}
    >
      {isSubmitting ? (label ?? 'Отправляется...') : (label ?? 'Отправить')}
    </BaseButton>
  );
};
